<template lang="pug">
  v-text-field(
    :value="value",
    :rules="rules",
    prepend-icon='far fa-calendar-alt',
    v-bind="$attrs",
    v-mask="mask",
    @click.native="$emit('click')",
    @input="$emit('update:value', $event)",
  )
</template>

<script>
import { mask } from 'vue-the-mask';
import { validateDate } from '@/utils/time';

export default {
  props: {
    value: {
      validator: prop =>
        ['string', 'number', 'object', 'undefined'].includes(typeof prop),
      required: true,
    },
  },

  directives: {
    mask,
  },

  data() {
    return {
      mask: '##/##/####',
      rules: [
        v => !!v || 'date is required',
        v => {
          return validateDate(v) || 'Invalid format';
        },
      ],
    };
  },
};
</script>
